<script setup lang="ts">
import CloseButton from "./elements/CloseButton.vue";
import {store} from "../store/Store";

const props = defineProps<{ title: string, extraClass: string, walletConnected: boolean, isDtw: boolean }>();

</script>

<template>
  <section>
    <div :class="['container-position-panel', extraClass]">
      <div class="alice-ticket-content" v-if="!store.useNarrowLayout">
        <o-table :data="store.leveragePositions" class="alice-balance-table" paginated pagination-position="top"
                 :per-page="(store.useNarrowLayout ? 1 : 3)">
          <o-table-column field="chainInstrumentId" label="Instrument" class="alice-position-column" v-slot="props">
            <!-- -->
            <div style="float: left;">
              <img v-bind:src="'/crypto-icons/' + props.row.buySymbol?.toLowerCase() + '.svg'"
                   class="alice-crypto-icon-small"/>
              <img v-bind:src="'/crypto-icons/' + props.row.sellSymbol?.toLowerCase() + '.svg'"
                   class="alice-crypto-icon-small"/>
            </div>
            <div style="float: left; padding: 2px 10px 10px 10px; font-weight: bold">{{ props.row.buySymbol }}/{{ props.row.sellSymbol }}</div>
          </o-table-column>
          <o-table-column field="stake" label="Stake" class="alice-position-column" v-slot="props">
            {{ props.row.stake }}
          </o-table-column>
          <o-table-column field="openPrice" label="Open Price" class="alice-position-column" v-slot="props">
            {{ props.row.openPrice }}
          </o-table-column>
          <o-table-column field="positionSize" label="Position Size" class="alice-position-column" v-slot="props">
            {{ props.row.unitsOfExposure }} {{ props.row.buySymbol }}
          </o-table-column>
          <o-table-column field="pl" label="P/L" class="alice-position-column" v-slot="props">
            <span :class="props.row.pl >= 0 ? 'positive-pl' : 'negative-pl'"><span v-if="props.row.pl > 0">+</span>{{ props.row.pl }} {{ props.row.sellSymbol }}</span>
          </o-table-column>
          <o-table-column field="" label="Actions" class="alice-position-column" v-slot="props">
            <div style="float: left; padding-left: 10px;">
              <CloseButton title="Close" extra-class='' :token="props.row.buySymbol + '/' + props.row.sellSymbol"
                           :chain-instrument-id="props.row.chainInstrumentId"></CloseButton>
            </div>
          </o-table-column>
        </o-table>
        <div v-if="props.walletConnected">
          <div v-if="store.leveragePositions.length == 0">
            <div class="positions-status">
              No positions currently
            </div>
          </div>
        </div>
        <div v-else>
          <div class="positions-status">
            {{ 'Please connect your wallet to see positions.' }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container-position-panel {
  display: block;
}

.alice-position-column {
  width: 100px;
}

.alice-crypto-icon-small {
  height: 30px;
}

.positions-status {
  margin-top: 20px;
}

.positive-pl
{
  color : green;
}

.negative-pl
{
  color : red;
}
</style>
